export default __webpack_public_path__ + "static/media/living-desktop.09ab5839.png";